export default "__VITE_ASSET__DkuhBQDQ__"